import { cn } from "~/lib/utils"

interface TennisBallProps {
  className?: string
  startColor?: string
  midColor?: string
  endColor?: string
  gradientId?: string
}

export const grayTennisBallColors = {
  startColor: 'rgb(113, 113, 123)',
  midColor: 'rgb(162, 162, 170)',
  endColor: 'rgb(73, 73, 80)',
  gradientId: 'tennis-ball-gradient-gray'
} as const;

export function TennisBall({
  className,
  startColor = "rgb(250, 204, 21)",
  midColor = "rgb(252, 222, 103)",
  endColor = "rgb(159, 128, 3)",
  gradientId = "tennis-ball-gradient"
}: TennisBallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={cn("fill-current", className)}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: startColor }} />
          <stop offset="50%" style={{ stopColor: midColor }} />
          <stop offset="100%" style={{ stopColor: endColor }} />
        </linearGradient>
      </defs>
      <path fill={`url(#${gradientId})`} d="M448 256a192.55 192.55 0 0032-2.68A224 224 0 00258.68 32 192.55 192.55 0 00256 64c0 105.87 86.13 192 192 192zM253.35 480c.94-5.67 1.65-11.4 2.09-17.18.37-4.88.56-9.86.56-14.79 0-105.87-86.13-192-192-192a192.55 192.55 0 00-32 2.68A224 224 0 00253.35 480z"/>
      <path fill={`url(#${gradientId})`} d="M289.61 222.39A222.53 222.53 0 01224 64a226.07 226.07 0 012-30A224.1 224.1 0 0034 226a226.07 226.07 0 0130-2 222.53 222.53 0 01158.39 65.61A222.53 222.53 0 01288 448c0 5.74-.22 11.53-.65 17.22q-.5 6.42-1.36 12.79A224.12 224.12 0 00478 286a226.07 226.07 0 01-30 2 222.53 222.53 0 01-158.39-65.61z"/>
    </svg>
  )
}
